import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VAutocomplete,{attrs:{"items":_vm.clientList,"item-value":"id","item-text":"name","label":"Client","clearable":_vm.clearable ? _vm.clearable : false,"readonly":_vm.readonly,"disabled":_vm.disabled,"rules":[_vm.requiredCheck()],"dense":_vm.dense,"hide-details":_vm.hideDetails ? _vm.hideDetails : false,"outlined":""},model:{value:(_vm.clientIdValue),callback:function ($$v) {_vm.clientIdValue=$$v},expression:"clientIdValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }